import ServerApi from 'shared/lib/api/ServerApi';

// Login-Award-Redesign (Etappe E): E-Mail-Code-Login gegen die bestehenden,
// in Etappe A gehaerteten Endpoints.
//   POST /api/v1/auth/email-login/send/     { email }        -> 201 { state:'sent' }
//   POST /api/v1/auth/email-login/confirm/  { email, code }  -> 200 { key, state, ... }
// useV1=true (Default) -> Pfad-Prefix /api/v1. Der Code ist 4-stellig
// (Backend generate_sms_code / EmailLoginConfirmSerializer code min=max=4).
class OtpApi extends ServerApi {
  send(email) {
    return super.post('/auth/email-login/send/', { email });
  }

  confirm(email, code) {
    return super.post('/auth/email-login/confirm/', { email, code });
  }
}

export default new OtpApi();
